<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您的意見記錄將不會被保留。" content_2="是否確認退出？"></QuitButton>
    </FabColumn>

    <ion-content>
      <div class="flow-content">
        <MainTitle text="謝謝"></MainTitle>

      <div v-if="show_join" class="content enable-scroll">
        <MainSubtitle text="賽馬會「智康健」腦退化檢測及社區支援計劃"></MainSubtitle>
        <MainDescribe text="謝謝您的參與，就近的分區機構將會與您聯絡。"></MainDescribe>
        <br>
        <MainDescribe text="最後，煩請閣下回答兩條問題，讓我們更了解您的需要。"></MainDescribe>
      </div>

      <div v-if="show_no_join">
        <MainSubtitle text=""></MainSubtitle>
        <MainDescribe text="謝謝您的回覆。"></MainDescribe>
        <br>
        <MainDescribe text="最後，煩請閣下回答兩條問題，讓我們更了解您的需要。"></MainDescribe>
      </div>

      <div v-if="show_pass">
        <MainSubtitle text=""></MainSubtitle>
        <MainDescribe text="最後，煩請閣下回答兩條問題，讓我們更了解您的需要。"></MainDescribe>
      </div>

      <ConfirmButton class="flow-confirm-button" text="繼續" position="relative" @click="goSurvey"></ConfirmButton>
      <TestNumber :number="user_info.number"></TestNumber>

      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import MainSubtitle from "../components/common/MainSubtitle";
import MainDescribe from "../components/common/MainDescribe";
import ConfirmButton from "../components/common/ConfirmButton";
import router from "../router";
import QuitButton from "../components/common/QuitButton";
import TestNumber from "../components/test/TestNumber";
import common from "../common";

export default {
  name: "SurveyPrepare",
  components: {
    TestNumber,
    QuitButton,
    ConfirmButton,
    MainDescribe,
    MainSubtitle,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  data() {
    return {
      show_join: false,
      show_no_join: false,
      show_pass: false,
      user_info: {},
    }
  },
  ionViewWillEnter() {
    common.getUserInfo().then(user_info => {
      this.user_info = user_info;
    })
    const type = this.$route.params.type;
    switch (type) {
      case 'join': this.show_join = true; break;
      case 'no_join': this.show_no_join = true; break;
      case 'pass': this.show_pass = true; break;
    }
  },
  methods: {
    goSurvey: function () {
      router.replace('/survey')
    }
  }
}
</script>

<style scoped>
  .content{
    max-height: 50dvh;
    overflow-y: auto;
  }

  .flow-confirm-button :deep(.relative) {
    margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
  }
</style>
